import React from "react";
import { Configuration } from "../context/ConfigurationContext";
import { useConnection } from "../context/ConnectionContext";
import FullView from "./full/FullView";
import SlimView from "./slim/SlimView";

type PitchRendererProps = {
  config: Configuration;
  thinConfig: Configuration;
};

const PitchRenderer: React.FC<PitchRendererProps> = ({ config, thinConfig }) => {
  const { isChallenge = false } = useConnection();
  return isChallenge ? <SlimView config={thinConfig} /> : <FullView config={config} />;
};

export default PitchRenderer;
